<template>
	<div class="flex flex-grow flex-col">
		<NuxtLoadingIndicator />
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
		<span
			v-if="userStore.user?.is_demo || userStore.user?.is_company_demo"
			class="text-white border-white pointer-events-none fixed bottom-0 end-0 z-[20] block border-s-2 border-t-2 bg-gradient-to-tr from-red-600 to-red-500 px-6 py-3 text-xl font-black shadow-2xl duration-300 rounded-ts-xl"
		>
			{{ $t("demo") }}
		</span>
	</div>
</template>

<script setup lang="ts">
const app = useNuxtApp()
const route = useRoute()
const loadingIndicator = useLoadingIndicator()
const companyStore = useCompanyStore()
const userStore = useUserStore()

watch(
	() => [route.path, route.query],
	(newRoute, oldRoute) => {
		if (newRoute[0] != oldRoute[0]) return
		loadingIndicator.finish()
	}
)

useHead(() => ({
	title: companyStore?.domainCompany?.title || app.$i18n.t("app_name"),
	htmlAttrs: {
		translate: "no",
		dir: app.$i18n.localeProperties.value.dir,
		lang: app.$i18n.localeProperties.value.code
	},
	bodyAttrs: {},
	meta: [
		{ charset: "utf-8" },
		{
			name: "viewport",
			content:
				"width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=0, interactive-widget=resizes-content, viewport-fit=cover"
		},
		{
			hid: "description",
			name: "description",
			content: companyStore?.domainCompany?.description || app.$i18n.t("app_description")
		},
		{ name: "format-detection", content: "telephone=no" },
		{ name: "msapplication-TileColor", content: companyStore?.domainCompany?.color || "#EA6939" },
		{ name: "theme-color", content: companyStore?.domainCompany?.color || "#EA6939" },
		{ name: "fontiran.com:license", content: app.$config.public.fontIranCode }
	],
	link: [
		{
			rel: "canonical",
			href: companyStore?.domainCompany
				? companyStore.domainCompany.baseurl + route.path.replace(/\/$/, "")
				: app.$config.public.siteUrl + route.path.replace(/\/$/, "")
		},
		!companyStore?.domainCompany
			? {
					rel: "apple-touch-icon",
					size: "180x180",
					href: "/apple-touch-icon.png"
				}
			: {},
		!companyStore?.domainCompany
			? {
					rel: "icon",
					type: "image/png",
					sizes: "32x32",
					href: "/favicon-32x32.png"
				}
			: {},
		!companyStore?.domainCompany
			? {
					rel: "icon",
					type: "image/png",
					sizes: "16x16",
					href: "/favicon-16x16.png"
				}
			: {},
		!companyStore?.domainCompany?.image_id
			? { rel: "icon", type: "image/x-icon", href: "/favicon.ico" }
			: {
					rel: "icon",
					type: "image/png",
					href: app.$config.public.baseUrl + companyStore.domainCompany?.image_thumb1
				},
		!companyStore?.domainCompany
			? {
					rel: "mask-icon",
					href: "/safari-pinned-tab.svg",
					color: companyStore?.domainCompany?.color || "#EA6939"
				}
			: {}
	]
}))
</script>
